module.exports = __webpack_public_path__ + "static/img/3-3.aa2e16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/3-3.jpg
// module id = ZpZl
// module chunks = 25